import * as React from 'react';

// import earth from '../../assets/image/earth.svg';
import LinearProgress from '@material-ui/core/LinearProgress';

import './style.scss';

const PreLoader = () => {
  return(
    <section className='preloader d-flex flex-column justify-center align-center'>
      {/* <img
        style={{width: '200px', height: '200px'}}
        src={earth} />
      <span>{'Loading...'}</span> */}
      <div
        className='loader-container'
        style={{ width: '90%' }}>
        <LinearProgress color='primary' />
      </div>
    </section>
  );
};

export default PreLoader;
